import React from "react";
import cn from "clsx";
import { isEmpty } from "../../utils/helpers";
import ExtraLabels from "./ExtraLabels";

export interface FieldLabelProps {
  /** The ID of the field's input element. */
  id: string;
  /** The label text. */
  label?: React.ReactNode;
  /** Alternative label text for assistive devices (e.g. screen readers) */
  ariaLabel?: string;
  /** Show/hide the label. */
  hideLabel?: boolean;
  /** Additional labels to display after the main one (e.g. required, optional, etc.) */
  extraLabels?: React.ReactNode | React.ReactNodeArray;
  /**
   * Additional class name(s) for the element.
   *
   * @default "field-label"
   */
  className?: string;

  IAgreeClassName?: string;
}

export default function Label({
  id,
  label,
  ariaLabel,
  extraLabels,
  hideLabel = false,
  className = "field-label"
}: FieldLabelProps) {
  return (
    <label
      htmlFor={id}
      className={cn("label", className, hideLabel && "sr-only")}
    >
      <span className="label-text">
        {ariaLabel ? <span aria-label={ariaLabel}>{label}</span> : label}
        {extraLabels && !isEmpty(extraLabels) && (
          <ExtraLabels labels={extraLabels} />
        )}
      </span>
    </label>
  );
}
